module.exports = __webpack_public_path__ + "img/products_icon_pink.a543084a.svg";